export enum WidgetType {
    'Text' = 'Text',
    'Video' = 'Video'
}
